var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoursesBoy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 140.5,
    height: 101.831,
    viewBox: "0 0 140.5 101.831",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#3f3d56;}.b{fill:#ccc;}.c{fill:#6c63ff;}.d{fill:#fff;}.e{fill:#a0616a;}.f{fill:#2f2e41;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-12 -450)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(12 450)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M266.808,146.5H182.76a1.512,1.512,0,0,0-1.51,1.51v49.657a1.512,1.512,0,0,0,1.51,1.51h84.048a1.512,1.512,0,0,0,1.51-1.51V148.01A1.512,1.512,0,0,0,266.808,146.5Zm1.174,51.167a1.176,1.176,0,0,1-1.174,1.174H182.76a1.176,1.176,0,0,1-1.174-1.174V148.01a1.176,1.176,0,0,1,1.174-1.174h84.048a1.176,1.176,0,0,1,1.174,1.174Z",
    transform: "translate(-181.25 -146.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 87,
    transform: "translate(0 6)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 0.839,
    cy: 0.839,
    r: 0.839,
    transform: "translate(2.181 2.097)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 0.839,
    cy: 0.839,
    r: 0.839,
    transform: "translate(4.697 2.097)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 0.839,
    cy: 0.839,
    r: 0.839,
    transform: "translate(7.214 2.097)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M353.274,340.315h-40.6a1.428,1.428,0,0,1-1.426-1.426V293.426A1.428,1.428,0,0,1,312.676,292h40.6a1.428,1.428,0,0,1,1.426,1.426v45.463A1.428,1.428,0,0,1,353.274,340.315Z",
    transform: "translate(-289.441 -267.591)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M383.169,410.194H359.347a2.1,2.1,0,1,1,0-4.194h23.822a2.1,2.1,0,1,1,0,4.194Z",
    transform: "translate(-327.724 -362.466)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M383.169,456.694H359.347a2.1,2.1,0,1,1,0-4.194h23.822a2.1,2.1,0,1,1,0,4.194Z",
    transform: "translate(-327.724 -401.165)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M383.169,503.694H359.347a2.1,2.1,0,1,1,0-4.194h23.822a2.1,2.1,0,1,1,0,4.194Z",
    transform: "translate(-327.724 -440.281)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M412.074,348.694h-9.227a2.1,2.1,0,0,1,0-4.194h9.227a2.1,2.1,0,1,1,0,4.194Z",
    transform: "translate(-363.927 -311.284)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 73,
    height: 3,
    rx: 1.5,
    transform: "translate(7 12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M909.1,506.257a1.626,1.626,0,0,0,.581-2.424l3.788-20.966-3.535-.047L907.3,503.553a1.635,1.635,0,0,0,1.8,2.7Z",
    transform: "translate(-785.019 -426.399)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M667.557,470.1l-1.342,6.375.168,14.26H668.9l1.174-13.924,1.845-5.872Z",
    transform: "translate(-554.45 -391.233)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M717.557,470.1l-1.342,6.375.168,14.26H718.9l1.174-13.924,1.845-5.872Z",
    transform: "translate(-596.062 -391.233)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M2.5,0H6.464V2.5H0A2.5,2.5,0,0,1,2.5,0Z",
    transform: "translate(108.614 98.989) rotate(2.599)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M2.5,0H6.464V2.5H0A2.5,2.5,0,0,1,2.5,0Z",
    transform: "translate(117.002 98.989) rotate(2.599)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 4.12,
    cy: 4.12,
    r: 4.12,
    transform: "translate(115.11 39.36)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M872.359,442.8c-1.363-2.139-5.9-7.47-12.629-3.075,0,0,1.594,13.337-2.265,20.551,0,0,8.891,2.684,13.756.168,0,0-1.678-11.24,0-13.421a9.046,9.046,0,0,0,1.344-2.3A2.163,2.163,0,0,0,872.359,442.8Z",
    transform: "translate(-744.022 -389.129)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M928.975,465.6l1.646.686a.624.624,0,0,1,.383.55l.151,3.629-3.691-.336Z",
    transform: "translate(-802.279 -412.066)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M846.08,568.6s-3.691,6.878-3.02,13.253l5.2.839,3.691-8.891-.839,9.059,5.368.168s3.523-13.085,2.349-14.26Z",
    transform: "translate(-731.967 -497.787)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M844.1,496.257a1.626,1.626,0,0,0,.581-2.424l3.788-20.966-3.535-.047L842.3,493.553a1.635,1.635,0,0,0,1.8,2.7Z",
    transform: "translate(-730.924 -418.077)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M861.324,447.647l-1.51-.168s-1.342-.336-1.845,1.51a28.91,28.91,0,0,0-.5,5.536l4.7-.168Z",
    transform: "translate(-744.023 -396.967)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M872.638,378.752c.148-.514.105-1.209-.393-1.4a1.781,1.781,0,0,0-.826.007,2.2,2.2,0,0,1-1.523-.419,4.386,4.386,0,0,1-1.135-1.535l-.457-.857a3.72,3.72,0,0,1-.259-.558,2.2,2.2,0,0,1,.587-2.195,3.184,3.184,0,0,1,2.175-.853,5.869,5.869,0,0,1,2.324.5,10.278,10.278,0,0,1,3.465,2.328,3.054,3.054,0,0,1,1.094,2.424,3.547,3.547,0,0,1-1.113,1.795l-1.786,1.885a2.626,2.626,0,0,1-1.1.81.9.9,0,0,1-1.131-.5A5.229,5.229,0,0,1,872.638,378.752Z",
    transform: "translate(-752.748 -333.288)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M777.4,751.668a.168.168,0,0,1-.168.168H728.918a.168.168,0,1,1,0-.336h48.315A.168.168,0,0,1,777.4,751.668Z",
    transform: "translate(-636.901 -650.005)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoursesBoy);
export default __webpack_public_path__ + "static/media/coursesBoy.b63e68a7893076810419cb0c14a9e55e.svg";
export { ForwardRef as ReactComponent };